import { FormattedMessage } from 'react-intl';

export const orderFeatures = (purchaseType?: string) => [
  {
    title: (
      <FormattedMessage
        id="payment.thankyou.order.features.gradedAssignments"
        defaultMessage="Access to graded assignments and exams"
      />
    ),
    description: (
      <FormattedMessage
        id="payment.thankyou.order.features.gradedAssignments.description"
        defaultMessage="Receive grades and feedback to track your progress and ensure you understand the material"
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id="payment.thankyou.order.features.shareableCertificate"
        defaultMessage="Shareable Certificate upon completion"
      />
    ),
    description: (
      <FormattedMessage
        id="payment.thankyou.order.features.shareableCertificate.description"
        defaultMessage="Earn a {certificateInfo} that you can add to your resume"
        values={{
          certificateInfo:
            // Hardcoded to verified for programs similar to legacy program detail page
            purchaseType === 'program'
              ? 'verified certificate for each course'
              : purchaseType === 'professional'
                ? 'professional certificate'
                : 'verified certificate',
        }}
      />
    ),
  },
  {
    title: (
      <FormattedMessage
        id="payment.thankyou.order.features.globalSupport"
        defaultMessage="24/7 Global Support"
      />
    ),
    description: (
      <FormattedMessage
        id="payment.thankyou.order.features.globalSupport.description"
        defaultMessage="edX helps learners around the world with 24/7 technical support in multiple languages"
      />
    ),
  },
];
